import { OpenItemsType, SingleOpenItemDetailsType } from "./openItemsTypes";

export const openItemsReducer = {
  resetError: (state: OpenItemsType) => {
    state.error = null;
  },
  resetSuccess: (state: OpenItemsType) => {
    state.success = null;
    state.commentsSuccess = null;
  },
  resetOpenItemsFetching: (state: OpenItemsType) => {
    state.fetching = false;
    state.commentsFetching = false;
  },
  resetAdminOpenItemsList: (state: OpenItemsType) => {
    state.adminOpenItemList = [];
  },
  resetClientOpenItemsList: (state: OpenItemsType) => {
    state.clientOpenItemList = [];
  },
  resetSingleOpenItem: (state: OpenItemsType) => {
    state.adminOpenItemSingle = {} as SingleOpenItemDetailsType;
  },
  resetOpenItemsCommentList: (state: OpenItemsType) => {
    state.openItemsCommentsList = []
  },
  resetEmailSuccess: (state: OpenItemsType) => {
    state.emailSuccess = null
  }
}